import React, { useEffect, useRef, useState } from 'react';
import { Formik, Form, Field } from 'formik';
import { useHistory, useLocation } from 'react-router-dom';
import * as Yup from 'yup';
import {
  Button,
  FormControl,
  Input,
  Box,
  Image,
  FormErrorMessage,
  IconButton,
  InputGroup,
  InputRightElement,
  Alert,
  AlertIcon,
  CloseButton,
  AlertDescription,
  Text,
} from '@chakra-ui/react';
import { ViewOffIcon } from '@chakra-ui/icons';
import { Post } from '../../utils/axiosuitls';
import { resetpass } from '../../utils/endpoints';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}
const ViewIconc = () => {
  return (
    <svg width='23' height='15' viewBox='0 0 23 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11.25 3.125C10.8984 3.16406 10.3516 3.24219 10 3.32031C10.1562 3.59375 10.2734 4.10156 10.3125 4.375C10.3125 5.58594 9.29688 6.5625 8.125 6.5625C7.8125 6.5625 7.30469 6.44531 7.07031 6.28906C6.95312 6.64062 6.875 7.14844 6.875 7.5C6.875 9.92188 8.82812 11.875 11.25 11.875C13.6719 11.875 15.625 9.92188 15.625 7.5C15.625 5.11719 13.6719 3.125 11.25 3.125ZM22.3438 6.95312C20.2344 2.8125 16.0156 0 11.25 0C6.44531 0 2.22656 2.8125 0.117188 6.95312C0.0390625 7.10938 0 7.34375 0 7.53906C0 7.69531 0.0390625 7.92969 0.117188 8.08594C2.22656 12.2266 6.44531 15 11.25 15C16.0156 15 20.2344 12.2266 22.3438 8.08594C22.4219 7.92969 22.4609 7.69531 22.4609 7.5C22.4609 7.34375 22.4219 7.10938 22.3438 6.95312ZM11.25 13.125C7.38281 13.125 3.82812 10.9766 1.95312 7.5C3.82812 4.02344 7.38281 1.875 11.25 1.875C15.0781 1.875 18.6328 4.02344 20.5078 7.5C18.6328 10.9766 15.0781 13.125 11.25 13.125Z'
        fill='#666666'
      />
    </svg>
  );
};
const NewPassword = () => {
  const [alert, setAlert] = useState({
    type: 'green',
    msg: '',
    visible: false,
  });
  const [isOpen, setIsOpen] = useState(false);
  const history = useHistory();

  let query = useQuery();
  const token = query.get('token');
  const email = query.get('email');
  const formRef = useRef();

  const initialValues = {
    password_confirmation: '',
    password: '',
  };
  const validationSchema = Yup.object({
    password_confirmation: Yup.string().required('New Password is required'),
    password: Yup.string().required('Confirm Password is required'),
  });

  async function onSubmit(fields, { setStatus, setSubmitting, resetForm }) {
    const data = {
      email: email,
      password: fields.password,
      password_confirmation: fields.password_confirmation,
      token: token,
    };
    return Post(resetpass, data)
      .then((data) => {
        resetForm();
        setAlert((prevState) => {
          return {
            ...prevState,
            ...{
              visible: true,
              msg: data.data.message,
              type: 'green',
            },
          };
        });
        history.push('/login');
      })
      .catch((error) => {
        setAlert((prevState) => {
          return {
            ...prevState,
            ...{
              visible: true,
              msg:
                error.response.data.message.current_password !== undefined
                  ? error.response.data.message.current_password
                  : error.response.data.message.password,
              type: 'red',
            },
          };
        });
      });
  }
  const onClickReveal = () => {
    setIsOpen(!isOpen);
  };
  useEffect(() => {
    document.addEventListener('keydown', (e) => {
      if (e.code === 'Enter') {
        if (formRef.current) {
          formRef.current.handleSubmit();
        }
      }
    });
  }, []);
  useEffect(() => {
    setTimeout(() => {
      setAlert((prevState) => {
        return {
          ...prevState,
          ...{
            visible: false,
          },
        };
      });
    }, 6000);
  }, [alert.visible]);
  const _close = () => {
    setAlert((prevState) => {
      return {
        ...prevState,
        ...{ visible: false },
      };
    });
  };
  return (
    <Box
      w='100vw'
      minH='90vh'
      d='flex'
      justifyContent='center'
      alignItems='center'
      flexDir='column'
      transform='translateY(-50%, -50%)'
    >
      <Box
        d='flex'
        justifyContent='center'
        alignItems='center'
        w={['85%', '80%', '70%', '55%', '35%']}
      >
        {alert.visible && (
          <Alert colorScheme={alert.type} mb='3'>
            <AlertIcon />
            <AlertDescription>
              {alert.type === 'red' ? alert.msg.map((e) => e) : alert.msg}
            </AlertDescription>
            <CloseButton position='absolute' right='8px' top='8px' onClick={_close} />
          </Alert>
        )}
      </Box>
      <Image src='./images/Logo.svg' width='300px' height='125px' objectFit='contain' />
      <Text
        fontSize={['24px', '28px', '32px', '36px']}
        fontWeight='700'
        style={{ fontFamily: 'Mulish, sans-serif' }}
        color='#222222'
        mb='2rem'
      >
        Change Password
      </Text>

      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
        innerRef={formRef}
      >
        {(props) => (
          <Box
            d='flex'
            justifyContent='center'
            alignItems='center'
            w={['85%', '80%', '70%', '55%', '35%']}
          >
            <Form
              style={{
                display: 'flex',
                width: '100%',
                flexDirection: 'column',
                padding: '0px 1rem',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                gap: '1rem',
              }}
            >
              <FormControl id='email' isInvalid={props.errors.password && props.touched.password}>
                <Field
                  as={Input}
                  type='password'
                  placeholder='New Password'
                  name='password'
                  autoComplete='off'
                  tabIndex='1'
                  fontSize='20px'
                  fontWeight='600'
                  style={{ fontFamily: 'Mulish, sans-serif' }}
                  borderRadius='10px'
                  h='50px'
                  border='1px solid rgba(0, 0, 0, 0.1)'
                  bg='#fcfcfc'
                />
                <FormErrorMessage> {props.errors.password} </FormErrorMessage>
              </FormControl>
              <FormControl
                id='password'
                isInvalid={
                  props.errors.password_confirmation && props.touched.password_confirmation
                }
              >
                <InputGroup>
                  <InputRightElement>
                    <IconButton
                      bg='transparent !important'
                      variant='ghost'
                      top={1}
                      aria-label={isOpen ? 'Mask password' : 'Reveal password'}
                      icon={isOpen ? <ViewOffIcon /> : <ViewIconc />}
                      onClick={(e) => onClickReveal(e)}
                    />
                  </InputRightElement>
                  <Field
                    as={Input}
                    type={isOpen ? 'text' : 'password'}
                    placeholder='Confirm Password'
                    name='password_confirmation'
                    autoComplete='off'
                    tabIndex='2'
                    fontSize='20px'
                    fontWeight='600'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    borderRadius='10px'
                    h='50px'
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    bg='#fcfcfc'
                  />
                </InputGroup>
                <FormErrorMessage> {props.errors.password_confirmation} </FormErrorMessage>
              </FormControl>
              <Button
                type='submit'
                colorScheme='blue'
                size='lg'
                onClick={(e) => {
                  props.handleSubmit(e);
                }}
                tabIndex='3'
                mt={4}
                bg='linear-gradient(90.57deg, #7B90F7 3.35%, #3E59DE 94.78%)'
                _hover={{ bg: 'linear-gradient(90.57deg, #6e81dd 3.35%, #3750c6 94.78%)' }}
                boxShadow='0px 4px 8px rgba(0, 0, 0, 0.1)'
                borderRadius='7px'
                loadingText='Logging In...'
                isLoading={props.isSubmitting}
                fontSize='22px'
                fontWeight='900'
                style={{ fontFamily: 'Mulish, sans-serif' }}
                color='#ffffff'
                w='100%'
                h='50px'
              >
                Change Password
              </Button>

              <Box
                d='flex'
                justifyContent='center'
                alignItems='center'
                w='100%'
                className='singnupText'
              >
                <Box as='a' className='signUp' ml='1' href='/login' style={{ cursor: 'pointer' }}>
                  Back to login
                </Box>
              </Box>
            </Form>
          </Box>
        )}
      </Formik>
    </Box>
  );
};
export default NewPassword;
